import template from './business-details.html';
import controller from './business-details.controller';
import './business-details.styl';

let businessDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default businessDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/business-details/business-details.component.js
 **/